var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 64,
    viewBox: "0 0 110 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_738_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2166 18.533V18.4689C60.409 17.8918 60.5373 17.3146 60.6014 16.7375C60.9221 14.493 60.6014 12.3126 59.896 10.1322C59.896 10.0681 59.8319 10.0681 59.8319 10.0681C59.8319 10.0681 59.383 10.1322 59.1906 10.1322C59.1265 10.1322 59.0623 10.1322 58.9982 10.1322H58.9341C60.3449 12.8256 60.7297 15.5831 60.2166 18.533Z",
    fill: "#7A7C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8699 10.0681C58.7416 10.2605 58.6134 10.3888 58.4851 10.5811C58.421 10.6453 58.421 10.6453 58.4851 10.7094C58.8057 11.5431 58.9981 12.3767 59.1264 13.2104C59.3829 14.8777 59.3188 16.4809 59.0623 18.1483C59.0623 18.2124 59.0623 18.2765 59.0623 18.2765C59.7677 15.5831 59.7035 12.8256 58.8699 10.0681Z",
    fill: "#7A7C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7255 31.1664C78.8136 35.7195 79.3267 40.2085 79.0701 44.6333C77.4669 44.0562 77.1463 42.5812 76.4409 41.2987C72.2084 33.475 67.8477 25.7796 63.7435 17.956C62.2685 15.1985 61.1142 14.8137 59.6393 17.0582C59.7675 13.6594 57.5872 15.6474 56.6894 16.6734C53.8677 19.8157 51.3026 23.1504 48.8657 26.6133C47.7755 28.2165 46.6854 30.2686 44.8898 30.2045C41.4269 30.1403 39.3106 32.0642 37.3868 34.1804C33.3467 38.6694 29.3066 43.0301 22.5731 43.2866C21.3547 43.3508 20.0721 44.1844 19.1102 44.954C12.5691 50.7255 5.96393 56.4329 0 63.9359C9.55511 63.9359 18.3407 63.8077 27.0621 64.0001C30.2044 64.0642 32.0641 63.2947 33.4108 60.0882C34.5651 57.3307 36.6814 54.8939 39.3106 52.9059C45.2745 48.2886 52.2004 46.0442 59.3186 44.0562C66.1162 42.1323 67.4629 38.477 63.6152 32.5131C62.7174 31.1023 61.3066 30.0762 60.4729 28.7295C58.485 25.459 55.5351 22.1884 59.0621 18.469C57.9719 23.5351 61.1142 26.7415 64.513 29.8838C70.0922 35.0141 71.2465 40.7856 67.0782 44.1844C64.5772 46.2365 61.9479 48.2245 58.9339 49.6995C54.7014 51.8157 49.4429 55.9199 44.4409 63.7436C49.4429 60.7937 57.01 57.2025 66.7575 55.6634C87.3427 52.3929 103.631 60.5371 109.403 63.7436C99.014 53.5472 88.6894 44.4409 82.7255 31.1664Z",
    fill: "#7A7C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2304 10.8377L59.1262 9.93991L55.9839 12.7616L55.6633 8.52909L51.9438 6.47699L55.8557 4.80965L56.6893 0.705444L59.4469 3.91186L63.6793 3.39883L61.499 7.05414L63.2304 10.8377Z",
    fill: "#7A7C7F",
    stroke: "#7A7C7F",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_738_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.403,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrey);
export default __webpack_public_path__ + "static/media/logo-grey.766f46242c56c5afe9b65ab366b3b773.svg";
export { ForwardRef as ReactComponent };